exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-small-dialog__activator__content{display:unset}", ""]);

// exports
